import { useTranslation } from 'react-i18next';
import { useStore, selectMembers } from '@/utils/store';

export default function MemberMultiSelect({ value = [], onChange, label }) {
  const { t } = useTranslation();
  const members = useStore(selectMembers);

  if (members.length === 0) return null;

  const toggleMember = (id) => {
    if (value.includes(id)) {
      onChange(value.filter((v) => v !== id));
    } else {
      onChange([...value, id]);
    }
  };

  return (
    <div>
      <label className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1.5 block">
        {label || t('members.assignMembers')}
      </label>
      <div className="flex gap-2 flex-wrap">
        {members.map((m) => {
          const selected = value.includes(m.id);
          return (
            <button
              key={m.id}
              type="button"
              onClick={() => toggleMember(m.id)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${
                selected
                  ? 'border-brand-500 bg-brand-50 dark:bg-brand-500/10 text-brand-700 dark:text-brand-400'
                  : 'border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:border-brand-400'
              }`}
            >
              {m.emoji ? (
                <span
                  className="w-5 h-5 rounded-full flex items-center justify-center text-xs"
                  style={{ backgroundColor: m.color + '20' }}
                >
                  {m.emoji}
                </span>
              ) : (
                <span
                  className="w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold text-white"
                  style={{ backgroundColor: m.color }}
                >
                  {m.initials}
                </span>
              )}
              {m.name}
            </button>
          );
        })}
      </div>
      {value.length === 0 && (
        <p className="text-[10px] text-gray-400 mt-1">{t('members.sharedByAll')}</p>
      )}
    </div>
  );
}
